import { useTranslation } from 'react-i18next'
import { useResponsiveValue } from '@machobear/design-system'
import ListingTableHeader from '@/components/listings-table-header'
import { FilterBar } from '@/components/search-filter'
import useMediaQuery from '@/hooks/use-media-query'
import { breakpoints } from '@/styles'
import { TabMenu } from '@/components/tabs'
import { Button } from '@/components/button'
import PageTitle from '@/components/page-title'
import { showAddSlotModal } from './add-a-slot-modal'

const ListingShowingsHeader = ({ tabCount, currentTab, setCurrentTab, onSearch, listingId }) => {
  const { t, i18n } = useTranslation()
  const displayTablet = useMediaQuery(`(max-width: ${breakpoints.tabletLandscape})`)
  const displayMobile = useResponsiveValue()({
    mobile: true,
    tablet: false
  })
  const isFrench = i18n.languages[0] === 'fr'

  const AddSlotButton = () => (
    <Button
      onClick={() =>
        showAddSlotModal({
          listingId
        })
      }
      theme="secondary"
      size="small"
      minWidth={isFrench ? '160px' : 'unset'}
    >
      {t('l.listing.showings.add_new_slot.button', 'Add new slot')}
    </Button>
  )

  const breadcrumbs = [
    {
      to: '/listings',
      label: t('l.listing.view.all_listings.link', 'All Listings')
    },
    {
      to: `/listing/${listingId}`,
      label: t('l.listing.view.dashboard.link', 'Dashboard')
    },
    {
      to: null,
      label: t('l.listing.view.showings.title', 'Showings')
    }
  ]

  const menuItems = [
    {
      key: 'upcoming',
      onClick: () => setCurrentTab('upcoming'),
      isActive: currentTab === 'upcoming',
      children: `${t('l.listing.showings.upcoming.button', 'Upcoming')} (${tabCount.upcoming})`
    },
    {
      key: 'history',
      onClick: () => setCurrentTab('history'),
      isActive: currentTab === 'history',
      children: `${t('l.listing.showings.history.button', 'History')} (${tabCount.history})`
    }
  ]

  return (
    <>
      <PageTitle>{t('l.listing.view.showings.title', 'Showings')}</PageTitle>
      <ListingTableHeader
        height={displayTablet ? undefined : 198}
        title={t('l.listing.view.showings.title', 'Showings')}
        onSearch={onSearch}
        buttonComponent={AddSlotButton}
        breadcrumbs={displayMobile ? false : breadcrumbs}
      >
        <FilterBar>
          <TabMenu
            options={menuItems}
            theme={displayMobile ? 'primary' : 'secondary'}
            size="medium"
          />
        </FilterBar>
      </ListingTableHeader>
    </>
  )
}

export default ListingShowingsHeader
